import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MobileSettingsMenu from './MobileSettingsMenu';
import MobileAccountSettings from './MobileAccountSettings';
import MobileNotificationSettings from './MobileNotificationSettingsPage';
import MobileSecurityPage from './MobileSecurityPage';
import MobilePrivacyPolicy from './MobilePrivacyPolicyPage';
import MobileTermsConditions from './MobileTermsConditionsPage';
import usePasskeyManagementAccess from 'app/auth/usePasskeyManagementAccess';

function MobileSettings(): JSX.Element {
  // SEE-226: gate the route as well as the menu entry, so a deep link can't
  // reach passkey management on a federated session. Unmatched paths already
  // fall through to the menu below.
  const { canManagePasskeys } = usePasskeyManagementAccess();

  return (
    <Routes>
      {/* Default route - show main settings menu */}
      <Route index element={<MobileSettingsMenu />} />

      {/* Sub-routes for each settings page */}
      <Route path="account" element={<MobileAccountSettings />} />
      <Route path="notifications" element={<MobileNotificationSettings />} />
      {canManagePasskeys && <Route path="security" element={<MobileSecurityPage />} />}
      <Route path="privacy" element={<MobilePrivacyPolicy />} />
      <Route path="terms" element={<MobileTermsConditions />} />

      {/* Fallback - redirect unknown sub-routes to main menu */}
      <Route path="*" element={<Navigate to="/settings" replace />} />
    </Routes>
  );
}

export default MobileSettings;
